export default __webpack_public_path__ + "static/media/Rose.a66d5b68.jpg";